import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { Modal } from 'react-bootstrap';

import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import faStar from "@fortawesome/fontawesome-free-solid/faStar";

import ContentService from '../../services/content_service';
import i18next from "i18next";

import config from "config";

const EntityImage = ({ image, index, isPrimary, onImageChange, onReplaceImage, onDeleteImage, hideZoom }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    ContentService.getEntityImage(image).then(setImageSrc).catch(err =>{
      console.log(err);
    });
  }, [image]);
  
  if (imageSrc) {
    return (
      <div className="device-image-container-parent">

        <div className="device-image-container">
          <img className="device-image-in-situ" src={imageSrc} 
            onClick={() => setShowImageModal(true)}
            onLoad={() => onImageChange() } 
            onError={(e) => onImageChange(e) }
          />
          
          {isPrimary && <FontAwesomeIcon icon={faStar}/>}

          {!hideZoom && <img className="device-image-zoom" src={`${config.WEB_BASE_URL}/images/icon/enlarge.svg`} onClick={() => setShowImageModal(true)} />}
        </div>

        <EntityImageModal 
          show={showImageModal}
          onHide={() => { setShowImageModal(false); }}
          imageSrc={imageSrc}
          showActions={onReplaceImage && onDeleteImage}
          onReplace={() => { onReplaceImage(index); }}
          onDelete={() => { onDeleteImage(index); setShowImageModal(false); }}
        />

      </div>
    );
  } else {
    return (<div className="loader">{ i18next.t('loading') }</div>);
  }
}

EntityImage.propTypes = {
  image: PropTypes.string.isRequired, 
  index: PropTypes.number.isRequired, 
  isPrimary: PropTypes.bool, 
  onImageChange: PropTypes.func.isRequired, 
  onReplaceImage: PropTypes.func, 
  onDeleteImage: PropTypes.func
};

const EntityImageModal = ({ show, onHide, imageSrc, showActions, onReplace, onDelete, title, subTitle }) => (
  <Modal dialogClassName="devices" show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>{title ? title : i18next.t("device-image")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
          {subTitle && <p>{subTitle}</p>}
          <img src={imageSrc} alt={i18next.t("device-image")} />
      </div>
      {showActions && (
        <div className="device-image-buttons">
          <button className="btn btn-sm btn-default" onClick={onReplace}>{i18next.t("replace-image")}</button>
          <button className="btn btn-sm btn_default red" onClick={onDelete}>{i18next.t("delete-image")}</button>
        </div>
      )}
    </Modal.Body>
  </Modal>
);

EntityImageModal.propTypes = {
  show: PropTypes.bool.isRequired, 
  onHide: PropTypes.func.isRequired, 
  imageSrc: PropTypes.string.isRequired, 
  showActions: PropTypes.array, 
  onReplace: PropTypes.func, 
  onDelete: PropTypes.func,
  title: PropTypes.string
};

export { EntityImage, EntityImageModal };